class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverTimeout = null;
    this.closeTimeout = null;
    this.isDesktop = window.matchMedia('(min-width: 990px)').matches;
    this.hoverSetup = false;
    
    // Add hover functionality for desktop
    if (this.isDesktop) {
      this.setupHover();
    }
    
    // Update on resize
    window.matchMedia('(min-width: 990px)').addEventListener('change', (e) => {
      this.isDesktop = e.matches;
      if (this.isDesktop && !this.hoverSetup) {
        this.setupHover();
      }
    });
  }

  setupHover() {
    if (this.hoverSetup) return; // Prevent duplicate listeners
    
    const summary = this.mainDetailsToggle.querySelector('summary');
    const menuContent = this.mainDetailsToggle.querySelector('.mega-menu__content') || 
                        this.mainDetailsToggle.querySelector('.header__submenu');
    
    if (!summary) return;

    // Bind handlers once
    this.boundMouseEnter = this.handleMouseEnter.bind(this);
    this.boundMouseLeave = this.handleMouseLeave.bind(this);

    // Open on hover
    this.mainDetailsToggle.addEventListener('mouseenter', this.boundMouseEnter);
    
    // Close on mouse leave with delay
    this.mainDetailsToggle.addEventListener('mouseleave', this.boundMouseLeave);
    
    // Keep open when hovering over the menu content
    if (menuContent) {
      menuContent.addEventListener('mouseenter', this.boundMouseEnter);
      menuContent.addEventListener('mouseleave', this.boundMouseLeave);
    }
    
    this.hoverSetup = true;
  }

  handleMouseEnter() {
    // Clear any pending close
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    
    // Open the menu
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      const summary = this.mainDetailsToggle.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'true');
      }
      this.onToggle();
    }
  }

  handleMouseLeave() {
    // Add a small delay before closing to allow moving to submenu
    this.closeTimeout = setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.close();
      }
    }, 200);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
